import Meeting from 'Data/Meeting/reducers';
import Modals from 'Data/Modals/reducers';
import SiteTitle from 'Data/SiteTitle/reducers';
import Snackbars from 'Data/Snackbars/reducers';

export default {
  Meeting,
  Modals,
  Snackbars,
  title: SiteTitle,
};
